import Cookies from 'js-cookie';
import { apiAction, logEntry } from '../utils/index';

import {
  SET_MODEL_THRESHOLD_CURRENT_PAGE,
  SET_MODEL_THRESHOLD_PAGE_FILTER,
  MODEL_THRESHOLD_MANAGEMENT_ERROR,
  GET_ALL_MODEL_DETAILS_THRESHOLDS,
  MODEL_THRESHOLD_IS_LOADING,
  SET_MODEL_THRESHOLD_DETAILS,
  SET_MODEL_THRESHOLD_CHANGE,
  UPDATE_MODEL_THRESHOLD_SHOW_SCREEN,
  UPDATE_MODEL_THRESHOLD_SAVE_STATUS,

} from '../constants/index';

import {
  MODEL_MANAGEMENT,
  CREATE_MODEL_THRESHOLD,
  UPDATE_MODEL_THRESHOLD,
  DELETE_MODEL_THRESHOLD,

} from '../constants/logs';


const envName = process.env.REACT_APP_ENV_NAME_SHORT;

// Thresholds

export const setThresholdsErrorThunk = err => dispatch => {
  let messageCode = err && err.response && err.response.data && err.response.data.errorMessage;
  messageCode = messageCode && messageCode.replace('[400]=>', '');
  dispatch(setThresholdError(messageCode, true));
  setTimeout(() => {
    //Hide the banner
    dispatch(setThresholdError(messageCode, false));
  }, 2500);
};

export const setThresholdError = (messageCode, status) => {
  return {
    type: MODEL_THRESHOLD_MANAGEMENT_ERROR,
    payload: {
      data: {
        isOpSuccessful: false,
        showBanner: status,
        isLoading: false,
        displayMessageCode: messageCode || ''
      }
    }
  };
};

export const getThresholdsThunk = (offset, limit, filter, modelId, modelCategoryId, widgetCode) => dispatch => {
  if (modelId) {
    dispatch(getThesholds(offset, limit, filter, modelId, modelCategoryId, widgetCode));
  }
};

export const setThresholdLoadingStatus = isLoading => ({
  type: MODEL_THRESHOLD_IS_LOADING,
  payload: { isLoading: isLoading }
});

export const setThresholdShowScreenStatusThunk = status => dispatch => {
  dispatch(setThresholdShowScreenStatus(status));
};

export const setThresholdShowScreenStatus = status => ({
  type: UPDATE_MODEL_THRESHOLD_SHOW_SCREEN,
  payload: { showAddEditScreen: status }
});

export const getThesholds = (offset, limit, filter, modelId, modelCategoryId, widgetCode) =>
  apiAction({
    url: `${process.env.REACT_APP_API_ENDPOINT_ADMIN1}/management/model/threshold`,
    data: {
      Offset: offset,
      Limit: limit,
      Filter: filter,
      ModelId: modelId,
      ModelCategoryId: modelCategoryId
    },
    method: 'GET',
    onLoad: status => setThresholdLoadingStatus(status),
    onSuccess: retData => setAllThesholdListThunk(retData),
    onFailure: err => setThresholdsErrorThunk(err),
    accessToken: Cookies.get(`access-${envName}`),
    widgetcode: widgetCode
  });

export const setAllThesholdListThunk = retData => dispatch => {
  let messageCode = retData && retData.message;
  let modelsThresholds = (retData && retData.modelsThresholds) || [];
  dispatch(setAllThresholdList(messageCode, modelsThresholds));
};

export const setAllThresholdList = (messageCode, modelsThresholds) => ({
  type: GET_ALL_MODEL_DETAILS_THRESHOLDS,
  payload: {
    data: {
      ThresholdsList: modelsThresholds,
      isLoading: false,
      displayMessageCode: messageCode,
      showBanner: false
    }
  }
});

export const describeThresholdThunk = (modelsThresholdId,modelCategoryId, widgetCode) => dispatch => {
  dispatch(describeThreshold(modelsThresholdId, modelCategoryId, widgetCode));
};

export const describeThreshold = (modelsThresholdId, modelCategoryId, widgetCode) =>
  apiAction({
    url: `${process.env.REACT_APP_API_ENDPOINT_ADMIN1}/management/model/threshold/describe`,
    data: {
      ModelThresholdId: modelsThresholdId || undefined,
      ModelCategoryId: modelCategoryId || undefined
    },
    method: 'GET',
    onLoad: status => setThresholdLoadingStatus(status),
    onSuccess: retData => setdescribeThresholdThunk(retData),
    onFailure: err => setThresholdsErrorThunk(err),
    accessToken: Cookies.get(`access-${envName}`),
    widgetcode: widgetCode
  });

export const setdescribeThresholdThunk = retData => dispatch => {
  dispatch(setDescribeThreshold(retData));
};

export const setDescribeThreshold = ({ retData }) => ({
  type: SET_MODEL_THRESHOLD_DETAILS,
  payload: retData
});

export const setThresholdChangeThunk = retData => dispatch => {
  dispatch(setThresholdChange(retData));
};

export const setThresholdChange = retData => ({
  type: SET_MODEL_THRESHOLD_CHANGE,
  payload: retData
});

export const postThresholdThunk = (modelThreshold, widgetCode) => dispatch => {
  let url = '/management/model/threshold/save';
  let actionName = modelThreshold.PerformDelete
    ? DELETE_MODEL_THRESHOLD
    : modelThreshold.ModelThresholdId === 0
    ? CREATE_MODEL_THRESHOLD
    : UPDATE_MODEL_THRESHOLD;

  let log = logEntry(MODEL_MANAGEMENT, actionName, modelThreshold);
  dispatch(saveThreshold(modelThreshold, url, log, widgetCode));
};

export const saveThreshold = (modelThreshold, url, log, widgetCode) =>
  apiAction({
    url: `${process.env.REACT_APP_API_ENDPOINT_ADMIN1}${url}`,
    method: 'POST',
    onLoad: status => setThresholdLoadingStatus(status),
    onSuccess: retData => setThresholdStatusThunk(retData),
    onFailure: err => setThresholdsErrorThunk(err),
    accessToken: Cookies.get(`access-${envName}`),
    data: {
      Threshold: modelThreshold,
      log: log
    },
    widgetcode: widgetCode
  });

export const setThresholdStatusThunk = retData => dispatch => {
  let messageCode = retData && retData.message;
  let modelsThresholds = (retData && retData.modelsThresholds) || [];

  dispatch(setThresholdStatusAndData(messageCode, modelsThresholds, true));
  setTimeout(() => {
    //Hide the banner
    dispatch(setThresholdStatus('hhhh', false));
  }, 2500);
};

export const setThresholdStatusAndData = (messageCode, data, status) => ({
  type: UPDATE_MODEL_THRESHOLD_SAVE_STATUS,
  payload: {
    data: {
      ThresholdsList: data,
      isOpSuccessful: true,
      showBanner: status,
      isLoading: false,
      showAddEditScreen: false,
      displayMessageCode: messageCode || ''
    }
  }
});

export const setThresholdStatus = (messageCode, status) => ({
  type: UPDATE_MODEL_THRESHOLD_SAVE_STATUS,
  payload: {
    data: {
      isOpSuccessful: true,
      showBanner: status,
      isLoading: false,
      displayMessageCode: messageCode || ''
    }
  }
});

export const setCurrentPage = currentPage => ({
  type: SET_MODEL_THRESHOLD_CURRENT_PAGE,
  payload: { currentPage }
});

export const setPageFilter = filter => ({
  type: SET_MODEL_THRESHOLD_PAGE_FILTER,
  payload: { filter }
});
